<template>
  <div class="card-2022-dark card dash-card" style="min-height: 64px;">
    <div class="card-header dash-card-header" style="height: 20px; background: transparent; ">
      <h3 class="h3-dark narrow_05">*{{ $t('Webportal.Dashboard.NetPromoterScore') }} {{ getSinceWhenText }}</h3>
    </div>
    <div class="card-body dash-card-body card-body-spacer">
      <div class="tiny">{{ $t('Webportal.Dashboard.Score') }} = {{ $t('Webportal.Dashboard.Promoters') }} - {{ $t('Webportal.Dashboard.Detractors') }}</div>
      <div class="tiny">({{ $t('Webportal.Dashboard.Range') }} {{ $t('Webportal.Dashboard.from') }} +100 {{ $t('Webportal.Dashboard.to') }} -100)</div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'NpsLegend',

    props: {
      sinceWhenText: { type: String, default: function() { return '(' + this.$t('Webportal.Dashboard.since') + ' Q1 2019)'; }},
      showSinceWhen: { type: Boolean, default: function() { return true; }}
    },
    computed: {
      getSinceWhenText: function() {
        return this.showSinceWhen ? this.sinceWhenText : '';
      }
    },
  }

</script>

<style lang="scss" scoped>

  .card-body-spacer {
    padding: 0px;
  }

  h3{
    font-size: 10pt;
    margin: 0pt;
    text-align: left;
    font-stretch: extra-condensed;
    white-space: normal;
    margin-top: 4px;
    font-weight: bold;
    margin-left: 0.75rem;
  }
  
  .tiny {
    line-height: 1rem;
    font-size: 10pt;
    text-align: left;
    margin-left: 0.75rem;
  }

  .dash-card-header:first-child {
    border-radius: unset;
    margin: unset;
    padding: unset;
  }
</style>
